const ExpiredPage = ({ company }) => {
    return (
        <div className="flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-xl w-full bg-white shadow-md rounded-2xl p-8 space-y-6 text-gray-800">
                <h1 className="text-2xl font-semibold text-red-600 text-center">
                    This Background Check Invitation is No Longer Active
                </h1>

                <p>
                    Your invitation to complete a background check questionnaire has expired. If you have
                    already completed the background questionnaire, you may close this window.
                </p>

                <p>
                    If you did not complete the questionnaire, please contact {company.name} for assistance.
                </p>

                <div className="border-t pt-4 space-y-1 text-sm text-gray-700">
                    <p className="font-semibold">{company.name}</p>
                    <p>{company.address?.addressLine1}</p>
                    <p>{company.address?.city}, {company.address?.state} {company.address?.zipCode} {company.address?.country}</p>
                    <p>Phone: {company.contactPhone}</p>
                    <p>Email: {company.contactEmail}</p>
                </div>
            </div>
        </div>
    );
};

export default ExpiredPage
